module.exports = __webpack_public_path__ + "static/media/boy.63f8711b.jpg";